export default "__VITE_ASSET__JGaMnWYqo0Fg4JxB$LTbaA__"